import { useNavigate } from "react-router-dom";
import ButtonGradient from "../assets/svg/ButtonGradient";
import Collaboration from "../components/Collaboration";
import ConsistentStyleSection from "../components/styles";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Pricing from "../components/Pricing";
import Services from "../components/Services";
import {
  strk4,
  bld4,
  ismtrc4,
  kid4,
  msct4,
  smsct4,
  shd4,
  stckr4,
} from "../assets";
import UseCases from "../components/UseCases";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

const Landing = () => {
  const navigate = useNavigate();

  // Function to handle the click event
  const handleTryNowClick = () => {
    logEvent(analytics, "try_now_button_click", {
      screen: "Landing Page",
      button: "Try Now",
    });
    navigate("/signin"); // Navigate to the signin page
  };

  return (
    <>
      <div className="pt-[4.75rem] lg:pt-[5.25rem] overflow-hidden">
        <Header />
        <Hero />
        <UseCases />
        <ConsistentStyleSection
          styles={[
            { image: bld4, text: "Cute Strokes" },
            { image: kid4, text: "Cute Kids" },
            { image: shd4, text: "Flat Shaded" },
            { image: ismtrc4, text: "Flat Isometric" },
            { image: strk4, text: "Flat Strokes" },
            { image: msct4, text: "Funky Mascot" },
            { image: smsct4, text: "Shaded Mascot" },
            { image: stckr4, text: "Shaded Sticker" },
          ]}
        />
        <Collaboration />
        <Services />
        <Pricing />
        <Footer />
      </div>

      {/* Fixed Try Now Button */}
      <div className="fixed bottom-4 right-6 md:right-12 z-50 text-center">
        <button
          className="px-6 py-3 bg-gradient-to-r from-purple-600 via-blue-500 to-teal-300 text-white font-bold rounded-full shadow-lg hover:opacity-90 transition duration-300 ease-in-out"
          onClick={handleTryNowClick}
        >
          Try Now
        </button>
      </div>

      <ButtonGradient />
    </>
  );
};

export default Landing;
